import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import DownloadPage from "../pages/download/page";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsListPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import PerksPage from "../pages/perks/page";
import RulesPage from "../pages/rules/page";
import StatsPage from "../pages/stats/page";
import TermsOfService from "../pages/TermsOfService";
import VipPage from "../pages/vip/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vip",
    element: <VipPage />,
  },
  {
    path: "/stats",
    element: <StatsPage />,
  },
  {
    path: "/perks",
    element: <PerksPage />,
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    path: "/install",
    element: <Navigate to="/download" replace />,
  },
  {
    path: "/rules",
    element: <RulesPage />,
  },
  {
    path: "/news",
    element: <NewsListPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
